import { useState, useEffect } from 'react';
import { Images } from 'assets/images';
import { ProfileEdit } from './ProfileEdit/ProfileEdit';
import { useDispatch, useSelector } from 'react-redux';
import { SettingsLeftSection } from './SettingsLeftSection';
import { ROUTES } from 'utils/routeNames';
import { initialSettingsData } from './data';
import { settingsActions } from 'store';
import { useNavigate } from 'react-router-dom';
import {
  SettingsCategoryProfile,
} from 'utils/constant';
import {
  SettingsWrapper,
  MainSettingsContainer,
  BackToPrevPageBlock,
  IconToPrevPage,
  SettingsRightSection,
  CategoryName,
} from './styled';

const Settings = () => {
  const { user } = useSelector(({ auth }) => auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState(initialSettingsData);
  const [clonedData, setClonedData] = useState(currentUser);
  const [categoryName, setCategoryName] = useState(SettingsCategoryProfile);
  const [isRemoveAvatar, setIsRemoveAvatar] = useState(0);
  const [isChangedImage, setIsChangedImage] = useState(false);

  useEffect(() => {
    setClonedData(currentUser);
  }, [currentUser]);

  useEffect(() => {
    if (user) {
      setCurrentUser(user.data);
      dispatch(settingsActions.getCountries());
      dispatch(settingsActions.getCities(user?.data?.country?.id));
    }
  }, [dispatch, user]);

  return (
    <SettingsWrapper>
      <MainSettingsContainer>
        <BackToPrevPageBlock>
          <IconToPrevPage
            src={Images.backVector}
            onClick={() => navigate(ROUTES.HOME)}
          />
        </BackToPrevPageBlock>

        <SettingsLeftSection
          currentUser={currentUser}
          setCurrentUser={setCurrentUser}
          categoryName={categoryName}
          setCategoryName={setCategoryName}
          setIsRemoveAvatar={setIsRemoveAvatar}
          isRemoveAvatar={isRemoveAvatar}
          setIsChangedImage={setIsChangedImage}
        />

        <SettingsRightSection>
          <CategoryName>{categoryName}</CategoryName>
          <ProfileEdit
              clonedData={clonedData}
              setClonedData={setClonedData}
              isRemoveAvatar={isRemoveAvatar}
              currentUser={currentUser}
              setCurrentUser={setCurrentUser}
              isChangedImage={isChangedImage}
              setIsChangedImage={setIsChangedImage}
          />
        </SettingsRightSection>
      </MainSettingsContainer>
    </SettingsWrapper>
  );
};

export default Settings;
